export default "__VITE_ASSET__DL9q8igZ__"